import {setSnackbar} from "../../../Redux/snackBarSlice";


const validateData = (data,validationSchema) => {
    const { error } = validationSchema.validate(data, {
        abortEarly: false,
    });
    if (error) {
        return error.details.reduce((acc, detail) => {
            acc[detail.path[0]] = detail.message;
            return acc;
        }, {});
    } else {
        return {};
    }
};

const validateField = (field, value,setData ,data,validationSchema,setErrors) => {
    setData({ ...data, [field]: value.trim() });
    const newErrors = validateData(data,validationSchema);

    setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: newErrors[field] || "",
    }));


};

const validateForm = (data,setErrors,validationSchema,condition = false, nullField = null) => {
    if (condition&& nullField) data[nullField] = null;

    const newErrors = validateData(data,validationSchema);
    if (Object.keys(newErrors).length === 0) {
        return true;
    }
    console.log(newErrors)
    setErrors(newErrors);
    return false;
};

// Handle form submission
const submitFormWithValidation = async (data,condition=false, nullField,setErrors,validationSchema) => {
    if (validateForm(data,setErrors,validationSchema,condition, nullField)) {
        return data;
    } else {
        return null;
    }
};

const validateUniqueness=(data,newItem,name,notUniqueCallBack,dispatch)=>{
    const isUnique = data.every((item) =>
        Object.keys(newItem).every(
            (key) =>
                item[key]?.toString().toUpperCase() !==
                newItem[key]?.toString().toUpperCase()
        )
    );

    if (!isUnique) {
        notUniqueCallBack();
        dispatch(
            setSnackbar({
                open: true,
                message: `This ${name} already exists. Try a different one.`,
                error: true,
            })
        );
    }
    return isUnique;
}
export {submitFormWithValidation,validateField,validateData,validateUniqueness,validateForm};
